import { Box } from '@mui/joy';
import { FC } from 'react';

import { API_CONFIG } from '../api/config/env';

const ENV_LABEL: Record<string, string> = {
  dev: 'DEV',
  qa: 'QA',
  stg: 'STG',
};

/**
 * VITE_ENV 가 prod 가 아닐 때 화면 우측 하단에 작은 배지로
 * 테스트용 페이지임을 표시한다. prod 환경에서는 아무것도 렌더링하지 않는다.
 * pointer-events:none 이라 아래의 버튼/콘텐츠 클릭을 가로채지 않는다.
 */
const EnvBadge: FC = () => {
  if (API_CONFIG.ENV === 'prod') {
    return null;
  }

  const label = ENV_LABEL[API_CONFIG.ENV] ?? API_CONFIG.ENV.toUpperCase();

  return (
    <Box
      aria-hidden
      sx={{
        position: 'fixed',
        right: 100,
        bottom: 16,
        zIndex: 2147483647,
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 2.5,
        py: 1.25,
        borderRadius: 100,
        backgroundColor: '#D32F2F',
        color: '#FFF',
        fontSize: 20,
        fontWeight: 700,
        letterSpacing: 0.5,
        lineHeight: '28px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.35)',
      }}>
      {`⚠️ 테스트용 · ${label}`}
    </Box>
  );
};

export default EnvBadge;
